import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die Tresor-API (`/api/vault`, core-api-service). Der Tresor
 * sichert Portal-weit den "gesicherten Modus". Alle Endpunkte sind nutzerbezogen
 * und per JWT geschuetzt; uebertragen werden ausschliesslich Salze und verpackte
 * Schluessel (Zero-Knowledge).
 */
const vaultApi = axios.create({
  baseURL: '/api/vault',
  timeout: 30000,
});

vaultApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

vaultApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

export const vaultStatusApi = () => vaultApi.get('/status').then(data);
export const getVaultApi = () => vaultApi.get('').then(data);
export const createVaultApi = (vault) => vaultApi.post('', vault).then(data);
export const updateVaultApi = (vault) => vaultApi.put('', vault).then(data);

export default vaultApi;
